import Typography from '@mui/material/Typography';
import './styles.scss';
import { JSX } from 'react';
import 'rhyme-component-library/src/index.scss';

export default function Footer(): JSX.Element {
	return (
		<footer>
			<Typography variant="caption" style={{ color: 'var(--rhyme-accessible-blue)' }}>
				Rhyme Client Build {process.env.REACT_APP_ADO_BUILD_NUMBER} - {process.env.REACT_APP_ENV}
			</Typography>
		</footer>
	);
}
